import React from 'react'

const Homeperformence = () => {
  return (
    <section id="more-features" className="more-features section">
      <div className="container">
        <div className="row justify-content-around gy-4">
          <div className="col-lg-6 d-flex flex-column justify-content-center order-2 order-lg-1">
            <h3>PERFORMANCE MANAGEMENT</h3>
            <p /><p>Regular performance management with SigoHrm&nbsp;encourages your employees to aim for excellence. Then, your organization is set up for success and growth while .</p><p />
            <div className="row">
              <div className="col-lg-6 icon-box d-flex">
                <i className="bi bi-easel flex-shrink-0" />
                <div>
                  <p>360 Performance reviews and templates</p>
                </div>
              </div>{/* End Icon Box */}
              <div className="col-lg-6 icon-box d-flex">
                <i className="bi bi-patch-check flex-shrink-0" />
                <div>
                  <p>Management By Objectives</p>
                </div>
              </div>{/* End Icon Box */}
              <div className="col-lg-6 icon-box d-flex">
                <i className="bi bi-brightness-high flex-shrink-0" />
                <div>
                  <p>Self-Evaluation Tools</p>
                </div>
              </div>{/* End Icon Box */}
              <div className="col-lg-6 icon-box d-flex">
                <i className="bi bi-brightness-high flex-shrink-0" />
                <div>
                  <p>Performance reports</p>
                </div>
              </div>{/* End Icon Box */}
            </div>
          </div>
          <div className="features-image col-lg-5 order-1 order-lg-2">
            <img src="https://sigohrmlpadmin.loopring.in/front/images/homeperformencemanagements/9876.png" alt />
          </div>
        </div>
      </div>
    </section>

  )
}

export default Homeperformence
